
const ACTIONS = {
    CALL_API: 'call-api',
    SUCCESS: 'success',
    ERROR: 'error',

    SET_INITIAL_DATA: 'set-data',
    FILE_CHANGE: 'file-change',
    FILE_SET_ERRORS: 'file-set-errors',
    TEXT_SET_SUCCESS: 'text-set-success',
    TEXT_REMOVE_ERRORS: 'text-remove-errors',
    TEXT_AREA_CHANGE: 'text-area-change'
};

const fileInputDataReducer = (state, action) => {
    //console.log("file input dispatch triggered", state, action);

    switch (action.type) {
        case ACTIONS.SET_INITIAL_DATA: {
            return {
                ...state,
                //value: action.value,
                files: action.files,
                validation:{
                    ...state.validation,
                    isInvalid: false,
                    errors: [],
                    isValid: false,
                    successMsgs: []
                }
            };
        }
        case ACTIONS.FILE_CHANGE: {
            //console.log("state-FILECHANGE");
            //console.log(state);
            //console.log(action);

            if(action.files.length<1){
                //console.log(state.InputRef.current.value);
                (state.InputRef.current).value="";
            }
            
            return {
                ...state,
                //value: action.value,
                files: action.files,
                disabled: false,
                validation:{
                    ...state.validation,
                    isInvalid: false,
                    errors: [],
                    isValid: false,
                    successMsgs: []
                }
            };
        }

        case ACTIONS.TEXT_AREA_CHANGE: {
            //console.log("state-TEXTCHANGE");
            //console.log(state);
           
            var content = action.value;
            var count = 0;
            var maxLength = action.maxLength;

                //console.log(content);
                //console.log(content.substring(maxLength));
                var text = content.substring(0,maxLength);
                //console.log(content.length);
                //console.log(text.length);
                //setFeedbackMessage(text);
                //setFeedbackCharCount(text.length);
                
                return {
                    ...state,
                    value: text,
                    count: text.length,
                    validation:{
                        ...state.validation,
                        isInvalid: false,
                        errors: [],
                        isValid: false,
                        successMsgs: []
                    }
                };
        }
        case ACTIONS.FILE_SET_ERRORS: {
            //console.log("state");
            //console.log(state);

            return {
                ...state,
                validation:{
                    ...state.validation,
                    isInvalid: action.errors != null && action.errors.length > 0 ? true : false,
                    errors: action.errors,
                    isValid: false,
                    successMsgs: []
                }
            };
        }
        case ACTIONS.TEXT_SET_SUCCESS: {
            //console.log("setsuccess");
            //console.log(state);

            return {
                ...state,
                validation:{
                    ...state.validation,
                    isInvalid: false,
                    errors: [],
                    isValid: true,
                    successMsgs: action.successMsgs
                }
            };
        }
        case ACTIONS.TEXT_REMOVE_ERRORS: {
            const path = state.data[action.name];
            return {
                ...state,
                validation:{
                    ...path.validation,
                    isInvalid: false,
                    errors: [],
                    isValid: false,
                    successMsgs: []
                }
            };
        }
    }
}



export {ACTIONS, fileInputDataReducer};